import React, {useContext} from "react";
import Headroom from "react-headroom";
import "./Header.scss";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import StyleContext from "../../contexts/StyleContext";
import {
  greeting,
  workExperiences,
  techStack,
  skillsSection,
  openSource,
  blogSection,
  talkSection,
  achievementSection,
  educationInfo,
  bigProjects
} from "../../portfolio";

function Header() {
  const {isDark} = useContext(StyleContext);
  const viewEducation = educationInfo.display;
  const viewTechStack = techStack.display;
  const viewExperience = workExperiences.display;
  const viewOpenSource = openSource.display;
  const viewBigProjects = bigProjects.display;
  const viewSkills = skillsSection.display;
  const viewAchievement = achievementSection.display;
  const viewBlog = blogSection.display;
  const viewTalks = talkSection.display;

  return (
    <Headroom>
      <header className={isDark ? "dark-menu header" : "header"}>
        <a href="/" className="logo">
          {/* <span className="grey-color"> &lt;</span> */}
          <span className="logo-name">{greeting.username}</span>
          {/* <span className="grey-color">/&gt;</span> */}
        </a>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label
          className="menu-icon"
          htmlFor="menu-btn"
          style={{color: "white"}}
        >
          <span className={isDark ? "navicon navicon-dark" : "navicon"}></span>
        </label>
        <ul className={isDark ? "dark-menu menu" : "menu"}>
          {viewSkills && (
            <li>
              <a href="#skills">Навыки</a>
            </li>
          )}
          {viewTechStack && (
            <li>
              <a href="#stack">Стэк</a>
            </li>
          )}
          {viewEducation && (
            <li>
              <a href="#education">Образование</a>
            </li>
          )}
          {viewExperience && (
            <li>
              <a href="#experience">Опыт</a>
            </li>
          )}
          {viewBigProjects && (
            <li>
              <a href="#projects">Проекты</a>
            </li>
          )}
          {viewOpenSource && (
            <li>
              <a href="#opensource">Скачать</a>
            </li>
          )}
          {viewAchievement && (
            <li>
              <a href="#achievements">Ачивки</a>
            </li>
          )}
          {viewBlog && (
            <li>
              <a href="#blogs">Блог</a>
            </li>
          )}
          {viewTalks && (
            <li>
              <a href="#talks">Разговорчики</a>
            </li>
          )}
          <li>
            <a href="#contact">Связаться</a>
          </li>
          <li>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a className="toggle">
              <ToggleSwitch />
            </a>
          </li>
        </ul>
      </header>
    </Headroom>
  );
}
export default Header;
